import { Link } from 'types/InputsRedirectableLinkProps';

export function verifyIfFormCanSave(dataForm: Link, handleNotify: any) {
	if (dataForm.name === '') {
		handleNotify('Preenha o campo "Nome"', 'error');
		return false;
	}

	if (dataForm.redirect.type === '') {
		handleNotify('Preenha o campo "Tipo do redirecionamento"', 'error');
		return false;
	}

	if (dataForm.redirect.value === '') {
		handleNotify('Preenha o campo "Valor do redirecionamento"', 'error');
		return false;
	}

	return true;
}
